import React from 'react';
import { connect } from 'react-redux';

import { Theme, createStyles, withStyles } from '@material-ui/core';
import { FormControl } from '@material-ui/core';

import commonStyles from '../common/common.module.css';

import StationsModel from '../../models/Stations';
import Select from 'react-select';

const iconFontSize = 40;
const useStyles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    disabledIcon: {
      fontSize: iconFontSize,
      color: 'rgb(204, 204, 204)'
    },
    label: {
      minWidth: '355px'
    },
    helperText: {
      color: 'red',
      marginLeft: '10px'
    },
    prFields: {
      width: 'calc( 100% - 20px )',
      marginRight: '20px',
    },
    selectdropdown: {
      '& .css-yk16xz-control, & .css-1pahdxg-control, & .css-1fhf3k1-control': {
        borderRadius: 'var(--ip-br)',
        fontSize: '13px',
        minHeight: '30px !important',
        boxShadow: 'none',
        '&:hover': {
          border: '1px solid var(--primaryblue)',
        }
      },
      '& .css-tlfecz-indicatorContainer, & .css-1gtu0rj-indicatorContainer': {
        padding: '0 4px' 
      },
      '& .css-1okebmr-indicatorSeparator, & .css-109onse-indicatorSeparator': {
        display: 'none'
      },
      '& .css-g1d714-ValueContainer': {
        padding: '0 8px' 
      },
      '& .css-1wa3eu0-placeholder': {
        lineHeight: 1,
        fontSize: '12px',
      },
    },
    error:{
      fontSize: '10px',
      color: 'red'
    },
    '@media (max-width: 600px)':{
      prFields: {
        width: '100%',
        marginRight: '0px',
      },
    }
  });

interface StationDropDownProps {
  classes: any;
  items: Array<StationsModel>;
  value: string;
  allowedToChange?: boolean;
  onChange: (event: any) => void;
  valiant?: string ;
  labelText: string;
  type: 'truckingCompany' | 'fwdCompany';
  error?: string;
  onClick?: (event: any) => void;
  hasCreateNewCompany?: boolean;
  isEditMode: boolean;
};

interface Option {
  value: string;
  label: string;
};

const stationDropDown = (props: StationDropDownProps) => {

  const { classes } = props;
  const options: Array<Option> = props.items.map((item: any) => (
    {
      value: item.iata_code,
      label: item.iata_code
    }
  ));
  const getStationValue = (): Option => {
    const value: Array<Option> = options.filter((station: any) => station.value === props.value);
    return value[0];
  }
  const disabled = (props.type === 'truckingCompany' && !props.allowedToChange)?  true : false;
  const styleSelect:  string = props.type === 'fwdCompany' ? classes.select : '';
  const selectValue: any = props.value ? getStationValue() : null;

  return (
    <FormControl className={ `${ classes.prFields } ${ classes.selectdropdown }` }>
      <label className={ commonStyles.inputLabel }>Filter list for station</label>
      <Select 
        onChange={ props.onChange }           
        isDisabled={ disabled || props.isEditMode }
        options={ options }
        className={ styleSelect }
        value={ selectValue }
        onClick={ props.onClick }
      />
    </FormControl>
  );
};

const mapStateToProps = (state: any) => {
  return {
    isEditMode: state.manualEntryEdit.isEditMode
  }
}
  
export default withStyles(useStyles)(connect(mapStateToProps, {})(stationDropDown));